import React, { useEffect, useState } from 'react';
import './Sidebar.css';
import { NavLink, useNavigate } from 'react-router-dom';

function Sidebar() {
  const roleId = parseInt(localStorage.getItem('role_id'), 10) || 1;
  const navigate = useNavigate();
  const [blocking, setBlocking] = useState({ openCount: 0, exceptionApproved: false, loading: roleId === 1 });

  const roleLabel =
    roleId === 1 ? 'Researcher' :
    roleId === 2 ? 'ERC Staff' :
    roleId === 3 ? 'Reviewer' :
    roleId === 4 ? 'Secretary' :
    'User';

  useEffect(() => {
    if (roleId !== 1) return;
    const fetchOpen = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/proposals/my/open-count`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        setBlocking({ openCount: data.openCount || 0, exceptionApproved: !!data.exceptionApproved, loading: false });
      } catch {
        setBlocking(s => ({ ...s, loading: false }));
      }
    };
    fetchOpen();
  }, [roleId]);

  const submitDisabled =
    roleId === 1 && !blocking.loading && blocking.openCount > 0 && !blocking.exceptionApproved;

  const submitTitle =
    submitDisabled ? 'You have an active proposal. Request an exception if you must submit another.' : '';

  return (
    <div className="sidebar">
      {

}

      <ul className="menu">
        <li><NavLink to="/dashboard">Dashboard</NavLink></li>
        <li><NavLink to="/profile">My Profile</NavLink></li>

        {}
        {roleId === 1 && (
          <>
            <li
              title={submitTitle}
              style={{ pointerEvents: submitDisabled ? 'none' : 'auto', opacity: submitDisabled ? 0.5 : 1 }}
            >
              <NavLink to="/proposal/submit">Submit Proposal</NavLink>
            </li>

            {submitDisabled && (
              <li>
                <NavLink to="/exception/request" className="menu-link">
                  Request Exception
                </NavLink>
              </li>
            )}

            <li><NavLink to="/proposal/view-submissions">View Submissions</NavLink></li>
            {}
          </>
        )}

        {}
        {roleId === 2 && (
          <>
            <li><NavLink to="/inbox">Notifications</NavLink></li>
            <li><NavLink to="/proposal/view-submissions">View Submissions</NavLink></li>
            <li><NavLink to="/admin/users">User Management</NavLink></li>
          </>
        )}

        {}
        {roleId === 4 && (
          <>
            <li><NavLink to="/proposal/view-submissions">Proposals</NavLink></li>
            <li><NavLink to="/inbox">Notifications</NavLink></li>
            {}
            <li><NavLink to="/proposal/pending-meeting">Pending Meeting</NavLink></li>

            {}
            <li><NavLink to="/proposal/pending-approval">Ready Final Approval</NavLink></li>

            <li><NavLink to="/exceptions">Exception Requests</NavLink></li>
          </>
        )}

        {}
        {roleId === 3 && (
          <>
            <li><NavLink to="/inbox">My Review Tasks</NavLink></li>
            <li><NavLink to="/proposal/view-submissions">Assigned Proposals</NavLink></li>
          </>
        )}
      </ul>
    </div>
  );
}

export default Sidebar;
